import { FC } from 'react';
import FormField from '@app/shared/components/form-controls/form-field/FormField';
import {
  amountBasicFieldFormattingProps,
  numericBasicFieldFormattingProps,
} from '@app/shared/components/form-controls/form-field/form-field-patterns';
import styles from '../../capital-structure-item-form-2.module.scss';
import { BaseCellProps } from './types';
import { RegisterOptions } from 'react-hook-form';

interface EditableCellProps extends BaseCellProps {
  fieldName: string;
  shouldBeItalic: boolean;
  shouldBeDisabled: boolean;
  placeholder?: string;
  rules?: RegisterOptions;
}

const EditableTableCell: FC<EditableCellProps> = ({
  fieldName,
  isAmountField,
  shouldBeItalic,
  shouldBeDisabled,
  placeholder = '',
  rules,
}) => (
  <td className={shouldBeItalic ? styles['italic-input'] : undefined}>
    <FormField
      name={fieldName}
      disabled={shouldBeDisabled}
      {...(isAmountField ? amountBasicFieldFormattingProps : numericBasicFieldFormattingProps)}
      placeholder={placeholder}
      autoHeight
      rules={rules}
    />
  </td>
);

export default EditableTableCell;
